import React from "react"
import PropTypes from "prop-types"
import { Grid } from "@bw/bits"

const Teasers = ({ numberOfColumns, children }) => {
  return (
    <Grid columns={numberOfColumns} gap="large">
      {children}
    </Grid>
  )
}

Teasers.propTypes = {
  numberOfColumns: PropTypes.number,
}

Teasers.defaultProps = {
  numberOfColumns: 3,
}

export { Teasers }
